/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Pwrdby.QuickMD.Providers.Api
 * OpenAPI spec version: 1.0
 */
import {
  useInfiniteQuery,
  useQuery,
  useSuspenseInfiniteQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  ErrorApiOutContract,
  GetPharmacyOrdersExportParams,
  GetPharmacyOrdersParams,
  PharmacyOrderCollectionDoctorApiOutContract
} from '../pwrdbyQuickMDProvidersApi.schemas';

import { fetcher } from '@quickmd-llc/frontend-utils';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Get paginated pharmacy order collection with summary stats. Each row carries `CanTriggerFulfillment`: true
for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more
(and not yet submitted to the pharmacy). Pass `CanTriggerFulfillment=true` to return only those rows.
 */
export const getPharmacyOrders = (
    params?: GetPharmacyOrdersParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<PharmacyOrderCollectionDoctorApiOutContract>(
      {url: `https://providers-api.api.quick.md/api/v1/pharmacy/orders`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetPharmacyOrdersInfiniteQueryKey = (params?: GetPharmacyOrdersParams,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/pharmacy/orders`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPharmacyOrdersQueryKey = (params?: GetPharmacyOrdersParams,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/pharmacy/orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPharmacyOrdersInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmacyOrdersInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyOrders>>> = ({ signal }) => getPharmacyOrders(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmacyOrdersInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyOrders>>>
export type GetPharmacyOrdersInfiniteQueryError = void | ErrorApiOutContract


export function useGetPharmacyOrdersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPharmacyOrdersParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyOrders>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyOrders>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get paginated pharmacy order collection with summary stats. Each row carries `CanTriggerFulfillment`: true
for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more
(and not yet submitted to the pharmacy). Pass `CanTriggerFulfillment=true` to return only those rows.
 */

export function useGetPharmacyOrdersInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmacyOrdersInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get paginated pharmacy order collection with summary stats. Each row carries `CanTriggerFulfillment`: true
for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more
(and not yet submitted to the pharmacy). Pass `CanTriggerFulfillment=true` to return only those rows.
 */
export const prefetchGetPharmacyOrdersInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPharmacyOrdersInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPharmacyOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmacyOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyOrders>>> = ({ signal }) => getPharmacyOrders(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmacyOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyOrders>>>
export type GetPharmacyOrdersQueryError = void | ErrorApiOutContract


export function useGetPharmacyOrders<TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPharmacyOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyOrders>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrders<TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyOrders>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrders<TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get paginated pharmacy order collection with summary stats. Each row carries `CanTriggerFulfillment`: true
for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more
(and not yet submitted to the pharmacy). Pass `CanTriggerFulfillment=true` to return only those rows.
 */

export function useGetPharmacyOrders<TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmacyOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get paginated pharmacy order collection with summary stats. Each row carries `CanTriggerFulfillment`: true
for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more
(and not yet submitted to the pharmacy). Pass `CanTriggerFulfillment=true` to return only those rows.
 */
export const prefetchGetPharmacyOrdersQuery = async <TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPharmacyOrdersQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPharmacyOrdersSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmacyOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyOrders>>> = ({ signal }) => getPharmacyOrders(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmacyOrdersSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyOrders>>>
export type GetPharmacyOrdersSuspenseQueryError = void | ErrorApiOutContract


export function useGetPharmacyOrdersSuspense<TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPharmacyOrdersParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersSuspense<TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersSuspense<TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get paginated pharmacy order collection with summary stats. Each row carries `CanTriggerFulfillment`: true
for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more
(and not yet submitted to the pharmacy). Pass `CanTriggerFulfillment=true` to return only those rows.
 */

export function useGetPharmacyOrdersSuspense<TData = Awaited<ReturnType<typeof getPharmacyOrders>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmacyOrdersSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPharmacyOrdersSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmacyOrdersInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyOrders>>> = ({ signal }) => getPharmacyOrders(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmacyOrdersSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyOrders>>>
export type GetPharmacyOrdersSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPharmacyOrdersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPharmacyOrdersParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get paginated pharmacy order collection with summary stats. Each row carries `CanTriggerFulfillment`: true
for QuickMD Pharmacy orders at the caller's pharmacy that are `onhold`, or `sent` for 15 minutes or more
(and not yet submitted to the pharmacy). Pass `CanTriggerFulfillment=true` to return only those rows.
 */

export function useGetPharmacyOrdersSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrders>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrders>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmacyOrdersSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Export pharmacy orders as CSV
 */
export const getPharmacyOrdersExport = (
    params?: GetPharmacyOrdersExportParams,
 options?: SecondParameter<typeof fetcher>,signal?: AbortSignal
) => {
      
      
      return fetcher<Blob>(
      {url: `https://providers-api.api.quick.md/api/v1/pharmacy/orders/export`, method: 'GET',
        params,
        responseType: 'blob', signal
    },
      options);
    }
  



export const getGetPharmacyOrdersExportInfiniteQueryKey = (params?: GetPharmacyOrdersExportParams,) => {
    return [
    'infinite', `https://providers-api.api.quick.md/api/v1/pharmacy/orders/export`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetPharmacyOrdersExportQueryKey = (params?: GetPharmacyOrdersExportParams,) => {
    return [
    `https://providers-api.api.quick.md/api/v1/pharmacy/orders/export`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPharmacyOrdersExportInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmacyOrdersExportInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyOrdersExport>>> = ({ signal }) => getPharmacyOrdersExport(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmacyOrdersExportInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>
export type GetPharmacyOrdersExportInfiniteQueryError = void | ErrorApiOutContract


export function useGetPharmacyOrdersExportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPharmacyOrdersExportParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyOrdersExport>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyOrdersExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersExportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyOrdersExport>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyOrdersExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersExportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export pharmacy orders as CSV
 */

export function useGetPharmacyOrdersExportInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmacyOrdersExportInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Export pharmacy orders as CSV
 */
export const prefetchGetPharmacyOrdersExportInfiniteQuery = async <TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPharmacyOrdersExportInfiniteQueryOptions(params,options)

  await queryClient.prefetchInfiniteQuery(queryOptions);

  return queryClient;
}



export const getGetPharmacyOrdersExportQueryOptions = <TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmacyOrdersExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyOrdersExport>>> = ({ signal }) => getPharmacyOrdersExport(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmacyOrdersExportQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>
export type GetPharmacyOrdersExportQueryError = void | ErrorApiOutContract


export function useGetPharmacyOrdersExport<TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPharmacyOrdersExportParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyOrdersExport>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyOrdersExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersExport<TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPharmacyOrdersExport>>,
          TError,
          Awaited<ReturnType<typeof getPharmacyOrdersExport>>
        > , 'initialData'
      >, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersExport<TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export pharmacy orders as CSV
 */

export function useGetPharmacyOrdersExport<TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmacyOrdersExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Export pharmacy orders as CSV
 */
export const prefetchGetPharmacyOrdersExportQuery = async <TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 queryClient: QueryClient, params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}

  ): Promise<QueryClient> => {

  const queryOptions = getGetPharmacyOrdersExportQueryOptions(params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getGetPharmacyOrdersExportSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmacyOrdersExportQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyOrdersExport>>> = ({ signal }) => getPharmacyOrdersExport(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmacyOrdersExportSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>
export type GetPharmacyOrdersExportSuspenseQueryError = void | ErrorApiOutContract


export function useGetPharmacyOrdersExportSuspense<TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPharmacyOrdersExportParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersExportSuspense<TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersExportSuspense<TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export pharmacy orders as CSV
 */

export function useGetPharmacyOrdersExportSuspense<TData = Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmacyOrdersExportSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPharmacyOrdersExportSuspenseInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPharmacyOrdersExportInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPharmacyOrdersExport>>> = ({ signal }) => getPharmacyOrdersExport(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPharmacyOrdersExportSuspenseInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>
export type GetPharmacyOrdersExportSuspenseInfiniteQueryError = void | ErrorApiOutContract


export function useGetPharmacyOrdersExportSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(
 params: undefined |  GetPharmacyOrdersExportParams, options: { query:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersExportSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPharmacyOrdersExportSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient
  ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Export pharmacy orders as CSV
 */

export function useGetPharmacyOrdersExportSuspenseInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getPharmacyOrdersExport>>>, TError = void | ErrorApiOutContract>(
 params?: GetPharmacyOrdersExportParams, options?: { query?:Partial<UseSuspenseInfiniteQueryOptions<Awaited<ReturnType<typeof getPharmacyOrdersExport>>, TError, TData>>, request?: SecondParameter<typeof fetcher>}
 , queryClient?: QueryClient 
 ):  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPharmacyOrdersExportSuspenseInfiniteQueryOptions(params,options)

  const query = useSuspenseInfiniteQuery(queryOptions, queryClient) as  UseSuspenseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




